import api from './api';
import { fetchPage } from './pagedParams';

const permissionService = {
  getAllPermissions: async () => {
    const response = await api.get('/admin/permissions');
    return response.data;
  },

  getActivePermissions: async () => {
    const response = await api.get('/admin/permissions/active');
    return response.data;
  },

  getPermissionById: async (id) => {
    const response = await api.get(`/admin/permissions/${id}`);
    return response.data;
  },

  getPermissionWithUsage: async (id) => {
    const response = await api.get(`/admin/permissions/${id}/with-usage`);
    return response.data;
  },

  getPermissionsByResource: async (resource) => {
    const response = await api.get(`/admin/permissions/resource/${resource}`);
    return response.data;
  },

  createPermission: async (permissionData) => {
    const response = await api.post('/admin/permissions', permissionData);
    return response.data;
  },

  updatePermission: async (id, permissionData) => {
    const response = await api.put(`/admin/permissions/${id}`, permissionData);
    return response.data;
  },

  deletePermission: async (id) => {
    await api.delete(`/admin/permissions/${id}`);
  },

  // Server-side paged list (Spring Page) for the URL-driven DataTable.
  getPermissionsPage: (params) => fetchPage('/admin/permissions/paged', params),

};

export default permissionService;